import styled from 'styled-components';

export const LockedContentWrapper = styled.div`
    border-radius: 8px;
    background: var(--colors-overlay-grey-light, rgba(112, 118, 141, 0.2));
    top: 0;
    left: 0;
    width: 100%;
    max-width: 1140px;
    height: 100%;
    z-index: 1;
    position: absolute;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px); /* Safari support */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-xs, 8px);
`;

export const LockedInfo = styled.div`
    display: flex;
    width: 643px;
    margin: auto auto;
    padding: var(--spacing-md, 24px) var(--spacing-xl, 32px);
    flex-direction: column;
    align-items: center;
    border-radius: var(--border-radius-md_16, 16px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: #fff;
    > div {
        display: flex;
        padding: var(--spacing-sm, 16px);
        flex-direction: column;
        align-items: center;
        gap: var(--spacing-sm, 16px);
        align-self: stretch;
        > div {
            margin: auto auto;

            display: flex;
            width: 85px;
            height: 85px;
            padding: 16px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: var(--border-radius-round, 48px);
            background: #e7f4ff;
        }
        span {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            align-self: stretch;
        }
    }
`;

export const LockedButtons = styled.div`
    display: flex;
    padding: var(--spacing-xl, 32px) var(--spacing-sm, 16px);
    align-items: flex-start;
    gap: var(--spacing-sm, 16px);
    align-self: stretch;
`;
